export default __webpack_public_path__ + "static/media/illustration-study-1-n-m.32cf946f.webp";